import { opinionLabDimensions } from './opinion-lab-dimensions';

//TODO: The below code is a stop gap solution until we start receiving the updated URL from spinner
const getExpUserId = (context): string | null =>
  context.user && context.user.expUserId ? context.user.expUserId.toString() : null;

const getTuid = (context): string | null => (context.user && context.user.tuid ? context.user.tuid.toString() : null);

const getCookie = (name): string => {
  const cookies = document.cookie.match('\\b' + name + '=([^;]*)\\b');

  return cookies ? cookies[1] : null;
};

const getReplayCookie = () => {
  const replayCookie = getCookie('_cls_s');

  return replayCookie ? replayCookie : '';
};

const getCustomVar = (tuid, duaid, eid, glassBoxId) => {
  const customVar = 'duaid:' + duaid + '|' + 'tuid:' + tuid + '|' + 'eid:' + eid + '|' + '_cls_s:' + glassBoxId;

  return encodeURIComponent(customVar);
};

export const getLinkWithCookies = (link: string, context) => {
  const newLink = link.split('&custom_var')[0];
  const tuid = getTuid(context);
  const eid = getExpUserId(context);
  const duaid = context.deviceId;
  const glassBoxId = getReplayCookie();
  const customVar = getCustomVar(tuid, duaid, eid, glassBoxId);
  const height = screen.height;
  const width = screen.width;

  return newLink + '&cls_s=' + glassBoxId + '&height=' + height + '&width=' + width + '&custom_var=' + customVar;
};

/*
The openOpinionLab function will directly open the opinionLab link
 */
export function openOpinionLabPage(link) {
  const leftPosition = opinionLabDimensions.getLeft(screen.width);
  const topPosition = opinionLabDimensions.getTop(screen.height);
  const openedWindow = window.open(
    link,
    'ModalPopUp',
    `toolbar=no,
            scrollbars=no,
            location=no,
            statusbar=no,
            menubar=no,
            resizable=no,
            width=${opinionLabDimensions.width},
            height=${opinionLabDimensions.height},
            screenX=${leftPosition},
            screenY=${topPosition},
            left=${leftPosition},
            top=${topPosition}`
  );

  openedWindow.focus();
}
